import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    // 登录页
    path: '/',
    name: 'loginView',
    component: () => import('../views/LoginView.vue')
  },
  {
    // 登录页
    path: '/login',
    component: () => import('../views/LoginView.vue')
  },
  {
    // 索引页
    path: '/index',
    name: 'index',
    component: () => import('../views/IndexView.vue'),
    redirect: '/home',
    children: [
      {
        // 操作面板
        path: '/home',
        name: 'HomeView',
        component: () => import('../views/HomeView.vue')
      },
      {
        // 数据统计
        path: '/statistics',
        name: 'StatisticsView',
        component: () => import('../views/StatisticsView.vue')
      },
      {
        // 用户管理 - 用户列表
        path: '/employee',
        name: 'EmployeeView',
        component: () => import('../views/EmployeeView.vue')
      },
      {
        // 生成二维码
        path: '/generate-code',
        name: 'GenerateCodeView',
        component: () => import('../views/GenerateCodeView.vue')
      },
      {
        // 用户详情
        path: '/employee-details',
        name: 'EmployeeDetailsView',
        component: () => import('../views/EmployeeDetailsView.vue')
      },
      {
        // 用户楼层权限
        path: '/employee-floor',
        name: 'EmployeeFloorView',
        component: () => import('../views/EmployeeFloorView.vue')
      },
      {
        // 用户管理 - 导入用户
        path: '/import-employee',
        name: 'ImportEmployeeView',
        component: () => import('../views/ImportEmployeeView.vue')
      },
      {
        // 设备管理 - 设备列表
        path: '/controller',
        name: 'ControllerView',
        component: () => import('../views/ControllerView.vue')
      },
      {
        // 设备管理 - 常开常闭
        path: '/open-close',
        name: 'OpenCloseView',
        component: () => import('../views/OpenCloseView.vue')
      },
      {
        // 通行管理 - 自动注册 - 通行权注册模板
        path: '/automatic',
        name: 'AutomaticView',
        component: () => import('../views/AutomaticView.vue')
      },
      {
        // 通行管理 - 假期时间控制 - 假期控制模板
        path: '/wayleave-date',
        name: 'WayleaveDateView',
        component: () => import('../views/WayleaveDateView.vue')
      },
      {
        // 通行管理 - 假期时间控制 - 时间控制模板
        path: '/wayleave-time',
        name: 'WayleaveTimeView',
        component: () => import('../views/WayleaveTimeView.vue')
      },
      {
        // 访客管理 - 访客区域
        path: '/visitor-area',
        name: 'VisitorAreaView',
        component: () => import('../views/VisitorAreaView.vue')
      },
      {
        // 访客管理 - 申请配置
        path: '/visitor-config',
        name: 'VisitorConfigView',
        component: () => import('../views/VisitorConfigView.vue')
      },
      {
        // 通行记录
        path: '/card-record',
        name: 'CardRecordView',
        component: () => import('../views/CardRecordView.vue')
      },
      {
        // 实时记录
        path: '/real-time-record',
        name: 'RealTimeRecordView',
        component: () => import('../views/RealTimeRecordView.vue')
      },
      {
        // 系统设置 - 登录用户
        path: '/user',
        name: 'UserView',
        component: () => import('../views/UserView.vue')
      },
      {
        // 操作记录
        path: '/log-record',
        name: 'LogRecordView',
        component: () => import('../views/LogRecordView.vue')
      },
      {
        // 公司信息
        path: '/company',
        name: 'CompanyView',
        component: () => import('../views/CompanyView.vue')
      },
      {
        // 其他配置
        path: '/other-settings',
        name: 'OtherSettingsView',
        component: () => import('../views/OtherSettingsView.vue')
      },
      {
        // 用户详情
        path: '/employee-details',
        name: 'EmployeeDetailsView',
        component: () => import('../views/EmployeeDetailsView.vue')
      },
      {
        // 添加用户组
        path: '/add-department',
        name: 'AddDepartmentView',
        component: () => import('../views/AddDepartmentView.vue')
      },
      {
        // 修改用户组
        path: '/update-department',
        name: 'UpdateDepartmentView',
        component: () => import('../views/UpdateDepartmentView.vue')
      },
      {
        // 添加用户
        path: '/add-employee',
        name: 'AddEmployeeView',
        component: () => import('../views/AddEmployeeView.vue')
      },
      {
        // 修改用户
        path: '/update-employee',
        name: 'UpdateEmployeeView',
        component: () => import('../views/UpdateEmployeeView.vue')
      },
      {
        // 添加设备
        path: '/add-controller',
        name: 'AddControllerView',
        component: () => import('../views/AddControllerView.vue')
      },
      {
        // 添加区域组
        path: '/add-area',
        name: 'AddAreaView',
        component: () => import('../views/AddAreaView.vue')
      },
      {
        // 添加区域组
        path: '/update-area',
        name: 'UpdateAreaView',
        component: () => import('../views/UpdateAreaView.vue')
      },
      {
        // 修改设备
        path: '/update-controller',
        name: 'UpdateControllerView',
        component: () => import('../views/UpdateControllerView.vue')
      },
      {
        // 查看设备详情
        path: '/controller-details',
        name: 'ControllerDetailsView',
        component: () => import('../views/ControllerDetailsView.vue')
      },
      {
        // 通行权注册
        path: '/add-wayleave',
        name: 'AddWayleaveView',
        component: () => import('../views/AddWayleaveView.vue')
      },
      {
        // 通行权
        path: '/wayleave',
        name: 'WayleaveView',
        component: () => import('../views/WayleaveView.vue')
      },
      {
        // 新增模板
        path: '/add-template',
        name: 'AddTemplateView',
        component: () => import('../views/AddTemplateView.vue')
      },
      {
        // 修改模板
        path: '/update-template',
        name: 'UpdateTemplateView',
        component: () => import('../views/UpdateTemplateView.vue')
      },
      {
        // 新增常开常闭模板详情
        path: '/add-template-open-close',
        name: 'AddTemplateOpenCloseView',
        component: () => import('../views/AddTemplateOpenCloseView.vue')
      },
      {
        // 新增常开常闭模板详情
        path: '/update-template-open-close',
        name: 'UpdateTemplateOpenCloseView',
        component: () => import('../views/UpdateTemplateOpenCloseView.vue')
      },
      {
        // 新增假期详情
        path: '/add-wayleave-date',
        name: 'AddWayleaveDateView',
        component: () => import('../views/AddWayleaveDateView.vue')
      },
      {
        // 修改假期详情
        path: '/update-wayleave-date',
        name: 'UpdateWayleaveDateView',
        component: () => import('../views/UpdateWayleaveDateView.vue')
      },
      {
        // 个人中心
        path: '/personal',
        name: 'PersonalView',
        component: () => import('../views/PersonalView.vue')
      },
      {
        // 用户详情
        path: '/user-details',
        name: 'UserDetailsView',
        component: () => import('../views/UserDetailsView.vue')
      },
      {
        // 新增用户
        path: '/add-user',
        name: 'AddUserView',
        component: () => import('../views/AddUserView.vue')
      },
      {
        // 修改用户
        path: '/update-user',
        name: 'UpdateUserView',
        component: () => import('../views/UpdateUserView.vue')
      },
      {
        // 系统设置
        path: '/system-settings',
        name: 'SystemSettingsView',
        component: () => import('../views/SystemSettingsView.vue')
      },
      {
        // 访客记录
        path: '/visitor-record',
        name: 'VisitorRecordView',
        component: () => import('../views/VisitorRecordView.vue')
      },
      {
        // 访客详情
        path: '/visitor-details',
        name: 'VisitorDetailsView',
        component: () => import('../views/VisitorDetailsView.vue')
      },
      {
        // 添加访客区域
        path: '/add-visitor-area',
        name: 'AddVisitorAreaView',
        component: () => import('../views/AddVisitorAreaView.vue')
      },
      {
        // 添加访客区域
        path: '/add-visitor-area',
        name: 'AddVisitorAreaView',
        component: () => import('../views/AddVisitorAreaView.vue')
      },
      {
        // 修改访客区域
        path: '/update-visitor-area',
        name: 'UpdateVisitorAreaView',
        component: () => import('../views/UpdateVisitorAreaView.vue')
      },
      {
        // 修改访客区域设备
        path: '/add-visitor-area-controller',
        name: 'AddVisitorAreaControllerView',
        component: () => import('../views/AddVisitorAreaControllerView.vue')
      },
      {
        // 访客区域设备楼层
        path: '/visitor-area-controller-floor',
        name: 'VisitorAreaControllerFloorView',
        component: () => import('../views/VisitorAreaControllerFloorView.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
